import has from '@dojo/framework/core/has';
import { singleSvc, svc } from './conversation-svc';
export const asyncLoad = async (args) => {
    const { method, sessionid, site, product, data, author_id, select } = args;
    let response;
    if (has('ati-use-single-rpc')) {
        response = await singleSvc.reportsrpc({
            method,
            sessionid,
            site,
            product,
            author_id,
            data,
            select
        });
    }
    else {
        switch (method) {
            case 'conversations':
                response = await svc.conversations({
                    session_id: sessionid,
                    author_id: author_id,
                    select
                });
                break;
            case 'update_conversations':
                response = await svc.update_conversations({
                    session_id: sessionid,
                    data: data,
                    select
                });
                break;
            default:
                response = {};
                break;
        }
    }
    return response || [];
};
export default asyncLoad;
